import { formatUnits } from 'ethers'

import { MAX_TOKEN_DISPLAY_DECIMALS } from '@src/constants/exchange'
import { useFetchServerlessGasEstimates } from '@src/hooks/useFetchServerlessGasEstimates'
import { Balance } from '@src/utils/balance'
import { useTokensStore } from '@src/zustand_stores'

import { ChainSpecificGasDetailsProps } from './types'

// Helper function to format gas price without trailing zeros
function formatGasPrice(
    value: bigint,
    decimals: number = 9,
    maxDisplayDecimals: number = MAX_TOKEN_DISPLAY_DECIMALS
): string {
    const formattedValue = parseFloat(formatUnits(value, decimals))
    return formattedValue.toFixed(maxDisplayDecimals).replace(/\.?0+$/, '')
}

export function ChainSpecificGasDetails({ sellData }: ChainSpecificGasDetailsProps) {
    const getGasTokenProps = useTokensStore(state => state.getGasTokenProps)
    const { data: gasEstimates } = useFetchServerlessGasEstimates()

    // Check if we have gas estimates from serverless worker
    if (gasEstimates?.data && sellData.chainId) {
        const chainIdStr = sellData.chainId.toString()
        const chainData = gasEstimates.data[chainIdStr]

        if (chainData?.feeMetrics) {
            const { feeMetrics } = chainData

            // TRON Chain
            if (feeMetrics.isTron && feeMetrics.TronParams) {
                const { energyPrice, bandwidthPrice } = feeMetrics.TronParams
                return (
                    <>
                        <div className='flex justify-between'>
                            <span className='text-mach-sub-text'>Energy Price</span>
                            <span className='text-white'>{Number(energyPrice)} Sun</span>
                        </div>
                        <div className='flex justify-between'>
                            <span className='text-mach-sub-text'>Bandwidth Price</span>
                            <span className='text-white'>{Number(bandwidthPrice)} Sun</span>
                        </div>
                    </>
                )
            }

            // Solana Chain
            if (feeMetrics.isSolana && feeMetrics.SolanaParams) {
                const { feePerSignature } = feeMetrics.SolanaParams
                return (
                    <div className='flex justify-between'>
                        <span className='text-mach-sub-text'>Fee Per Signature</span>
                        <span className='text-white'>
                            {new Balance(getGasTokenProps(sellData.chainId))
                                .setValue(feePerSignature)
                                .formatWithCommas(MAX_TOKEN_DISPLAY_DECIMALS)}{' '}
                            {getGasTokenProps(sellData.chainId).symbol}
                        </span>
                    </div>
                )
            }
        }
    }

    return null
}
